"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerralabsResearch = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var CardRenderer_1 = require("../render/CardRenderer");
var TerralabsResearch = (function (_super) {
    __extends(TerralabsResearch, _super);
    function TerralabsResearch() {
        return _super.call(this, {
            name: CardName_1.CardName.TERRALABS_RESEARCH,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.EARTH],
            startingMegaCredits: 14,
            cardType: CardType_1.CardType.CORPORATION,
            cardCost: 1,
            metadata: {
                cardNumber: 'R14',
                description: 'You start with 14 M€. Lower your TR 1 step.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.br;
                    b.megacredits(14).nbsp.minus().tr(1);
                    b.corpBox('effect', function (ce) {
                        ce.effect('Buying cards to hand costs 1 M€.', function (eb) {
                            eb.cards(1).startEffect.megacredits(1);
                        });
                    });
                }),
            },
        }) || this;
    }
    TerralabsResearch.prototype.play = function (player) {
        player.decreaseTerraformRating();
        return undefined;
    };
    return TerralabsResearch;
}(Card_1.Card));
exports.TerralabsResearch = TerralabsResearch;
//# sourceMappingURL=TerralabsResearch.js.map